module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-bg@2x.20770848.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-bg@2x.png
// module id = 1287
// module chunks = 1